import React, { useState } from 'react';
import _ from 'lodash';
import { Button, Popover, FormControlLabel, Checkbox, FormGroup, Box, FormLabel } from '@material-ui/core';
import type { AutoReservationStatusQueryKey } from '@this/src/domain/arrangement/auto_reservation_status_query';
import {
  AutoReservationStatusQuery,
  AutoReservationStatusQueryKeys
} from '@this/src/domain/arrangement/auto_reservation_status_query';

interface Props {
  selectedStatuses: AutoReservationStatusQueryKey[];
  onChange: (statuses: AutoReservationStatusQueryKey[]) => void;
}

const AutoReservationStatusSelector: React.FC<Props> = ({ selectedStatuses, onChange }) => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked ? [...AutoReservationStatusQueryKeys] : []);
  };

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>, status: AutoReservationStatusQueryKey) => {
    onChange(e.target.checked ? selectedStatuses.concat([status]) : _.without(selectedStatuses, status));
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        onClick={e => setAnchorEl(e.currentTarget)}
        style={{ backgroundColor: 'white' }}
      >
        絞り込み
      </Button>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Box display="flex">
          <FormGroup style={{ padding: '5px' }}>
            <FormLabel>自動予約ステータス</FormLabel>
            <FormControlLabel
              label="すべて選択"
              control={
                <Checkbox
                  color="primary"
                  checked={selectedStatuses.length === AutoReservationStatusQueryKeys.length}
                  indeterminate={
                    selectedStatuses.length !== 0 &&
                    selectedStatuses.length !== AutoReservationStatusQueryKeys.length
                  }
                  onChange={handleSelectAll}
                />
              }
            />
            {AutoReservationStatusQueryKeys.map(key => (
              <FormControlLabel
                key={key}
                label={AutoReservationStatusQuery[key]}
                control={
                  <Checkbox
                    color="primary"
                    checked={selectedStatuses.includes(key)}
                    onChange={e => handleSelect(e, key)}
                  />
                }
              />
            ))}
          </FormGroup>
        </Box>
      </Popover>
    </>
  );
};

export default AutoReservationStatusSelector;
